
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termsAndPolicies",
      function () {
        return require("private-next-pages/termsAndPolicies.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termsAndPolicies"])
      });
    }
  